import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { MatchData } from "./MatchData";

const MatchDetails = () => {
  document.title = "Match Details| mrmto";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Match Details" />
          <MatchData />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MatchDetails;
